<template>
  <div className="this-page">
    <div class="editor" id="editor">

    </div>
    <div class="btn">
      <el-button type="primary" @click="save">保存内容</el-button>
    </div>
  </div>
</template>
<script>
import toolBar from '../../components/tool-bar/index.vue'
import E from "wangeditor"
let editor = null;
export default {
  components: {
    toolBar
  },
  data() {
    return {
      tableHeight: document.documentElement.clientHeight - 200 + 'px',
      load: {
        detail: false
      },
      detail: {}
    }
  },
  mounted() {
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;

        that.tableHeight = window.fullHeight - 165;  // 高

      })()
    };
    window.fullHeight = document.documentElement.clientHeight;

    let tableHeight = window.fullHeight - 250;  // 高
    this.getDetail()
    editor = new E("#editor")
    editor.config.height = tableHeight
    editor.config.zIndex = 1
    editor.config.uploadImgShowBase64 = true
    editor.create()
  },
  methods: {
    getDetail() {
      this.$fetch.post('Article/getDetail', {id: 2}, true).then(res => {
        this.load.detail = true
        this.detail = res
        editor.txt.html(res.content) // 重新设置编辑器内容
      })
    },
    save(){
      let content = editor.txt.html()
      console.log(content)
      this.$fetch.post('Article/updateContent', {id: 2,content:content}, true).then(res => {
        this.getDetail()
      })
    }
  }
}
</script>

<style scoped>
.this-page {
  padding: 10px;
  background-color: #FFFFFF;
}
.editor{
  width: 550px;
  margin: 30px auto;
}
.btn{
  width: 550px;
  margin: 0 auto;
}
</style>
